import { Image, StyleProps } from '@chakra-ui/react';

import BackButtonImg from 'assets/back_button_icon.png';

interface Properties {
  width?: number;
  height?: number;
  styles?: StyleProps;
}

const BackButton = ({ width = 34, height = 27, styles }: Properties) => {
  return <Image src={BackButtonImg} w={width} h={height} {...styles} />;
};

export default BackButton;
